import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export const inputCls =
  "flex h-10 w-full rounded-md border border-white/10 bg-[#0B0F17] px-3 py-2 text-sm text-slate-100 placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-[#CCFF00]/60";

export const Overline = ({ children, className = "" }) => (
  <p className={`font-mono text-[11px] font-semibold uppercase tracking-[0.2em] text-[#CCFF00] ${className}`}>{children}</p>
);

export const Panel = ({ className = "", children, ...props }) => (
  <div className={`rounded-lg border border-white/[0.08] bg-[#111827] p-5 sm:p-6 ${className}`} {...props}>
    {children}
  </div>
);

export const Stat = ({ label, value, testid, hint }) => (
  <Panel className="group transition-colors duration-300 hover:border-[#CCFF00]/40" data-testid={testid}>
    <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-slate-400">{label}</p>
    <p className="mt-3 font-display text-4xl font-extrabold tracking-tight text-white">{value}</p>
    {hint && <p className="mt-1 text-xs text-slate-500">{hint}</p>}
  </Panel>
);

export const Field = ({ label, children, hint }) => (
  <label className="block space-y-1.5">
    <span className="text-xs font-semibold uppercase tracking-wider text-slate-400">{label}</span>
    {children}
    {hint && <span className="block text-xs text-slate-500">{hint}</span>}
  </label>
);

const TONES = {
  green: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  amber: "bg-amber-500/10 text-amber-400 border-amber-500/30",
  red: "bg-rose-500/10 text-rose-400 border-rose-500/30",
  volt: "bg-[#CCFF00]/10 text-[#CCFF00] border-[#CCFF00]/30",
  cyan: "bg-cyan-500/10 text-cyan-300 border-cyan-500/30",
  slate: "bg-white/5 text-slate-300 border-white/10",
};

export const Pill = ({ tone = "slate", children, ...props }) => (
  <span className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 font-mono text-[10px] font-semibold uppercase tracking-wider ${TONES[tone]}`} {...props}>
    {children}
  </span>
);

export const Empty = ({ icon: Icon, title, text, children }) => (
  <div className="rounded-lg border border-dashed border-white/10 p-10 text-left">
    {Icon && <Icon className="mb-4 h-7 w-7 text-slate-500" />}
    <p className="font-display text-xl font-bold uppercase text-white">{title}</p>
    {text && <p className="mt-1 max-w-md text-sm text-slate-400">{text}</p>}
    {children && <div className="mt-5">{children}</div>}
  </div>
);

export const PageLoader = () => (
  <div className="flex min-h-[50vh] items-center justify-center" data-testid="page-loader">
    <Loader2 className="h-7 w-7 animate-spin text-[#CCFF00]" />
  </div>
);

export async function copyText(text, label = "Link copied") {
  try {
    await navigator.clipboard.writeText(text);
    toast.success(label);
  } catch {
    window.prompt("Copy this link:", text);
  }
}

export const H1 = ({ children, className = "" }) => (
  <h1 className={`font-display text-4xl font-black uppercase leading-none tracking-tight text-white sm:text-5xl ${className}`}>{children}</h1>
);
